import axios from "utils/axios";

// Отрмиуємо параметри
export const getSettings = async () => {
    try {
        const response = await axios('/settings'); 
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}

export const getModeForms = async () => {
    try {
        const response = await axios.get('/settings/mode-forms');
        return Array.isArray(response?.data) ? response.data : [];
    } catch (e) {
        console.error(e);
        return [];
    }
}

// Зберігаємо параметри
export const setSettings = async (settingsData) => {
    try {
        const response = await axios.post('/settings', settingsData); 
        return response.data?.stat||false;
    } catch(e){
        console.error(e);
        return null;
    }
} 

// Повертає додаткові поля site_settings (css,js)
export const getAdditional = async (fieldName) => {
    try {
        const response = await axios.get(`/settings/${fieldName}`);
        return response?.data?.value;
    } catch(e){
        console.error(e);
        return null;
    }
}
 
// Зберігає додаткові поля site_settings (css,js)
export const setAdditional = async (fieldName, value) => { 
    try {
        const response = await axios.post(`/settings/${fieldName}`, {value:value});
        return response?.data?.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }
}  

// Встановлюємо курс
export const setRate = async(rate) =>{
    try {
        const response = await axios.post('/settings/rate', {rate:rate});
        return response.data;
    } catch(e){
        console.error(e);
        return false;
    }
}

export const getTelegramBotStatus = async () => {
    try {
        const response = await axios.get('/settings/telegram-bot/status');
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
}

export const setTelegramBotToken = async (token) => {
    try {
        const response = await axios.post('/settings/telegram-bot/token', { token });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
}

export const deactivateTelegramBot = async () => {
    try {
        const response = await axios.post('/settings/telegram-bot/deactivate');
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
}